import React from 'react';
import styled from 'styled-components';
import {useAppContext} from 'contexts/ApplicationContext';
import {parseHtmlString} from 'shared/helpers/HTMLParser';
import {ControlButtons} from './ControlButtons';

export const Sidebar = () => {
    const {userProfile} = useAppContext();

    return (
        <SidebarContainer className="cbc-form">
            <ControlButtons />

            <Information>
                {parseHtmlString(userProfile?.manufacturerContactInfo ?? '')}

                <br />
                <br />
                {userProfile?.manufacturerTermsAndConditions ? (
                    <a
                        href={userProfile.manufacturerTermsAndConditions}
                        target="_blank"
                        rel="noreferrer">
                        Terms & Conditions
                    </a>
                ) : null}
                <br />
                {userProfile?.manufacturerPrivacyPolicy ? (
                    <a
                        href={userProfile.manufacturerPrivacyPolicy}
                        target="_blank"
                        rel="noreferrer">
                        Privacy Policy
                    </a>
                ) : null}
            </Information>
        </SidebarContainer>
    );
};

const SidebarContainer = styled.div`
    margin: 15px 0;
    padding: 0;
`;

const Information = styled.div`
    font-size: 0.9em;
    color: #595959;

    > h1,
    > h2,
    > h3 {
        color: ${({theme}) => theme.colors.secondary?.main};
        font-weight: bold;
        background: none;
        text-transform: initial;
        margin: initial;
        padding: initial;
        width: initial;
        text-align: initial;
        border-radius: initial;

        &:is(h1) {
            font-size: 2rem;
        }
        &:is(h2) {
            font-size: 1.5rem;
        }
        &:is(h3) {
            font-size: 1.25rem;
        }
    }
`;
